import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { registerNewUser } from "../service/APIService";

const initialState: any = {
    billing: {},
    receiving: {},
    requester: {},
    shipping: {},
    productHandling: {},
    billingPTRA: {},
    dropdownData: {},
    dropDownValuesLoaded: false
};

export const formDataSlice = createSlice({
    name: 'formDataSlice',
    initialState,
    reducers: {
        setBillingInformation: (state, action) => {
            state.billing = action.payload;
        },
        setReceivingInformation: (state, action) => {
            state.receiving = action.payload;
        },
        clearReceivingInformation: (state) => {
            state.receiving = {};
        },
        
        
        setRequestorInformation: (state, action) => {
            state.requester = action.payload;
        },
        clearRequestorInformation: (state) => {
            state.requester = {};
        },
        setShippingInformation: (state, action) => {
            state.shipping = action.payload;
        },
        clearShippingInformation: (state) => {
            state.shipping = {};
        },
        setProductHandlingInformation: (state, action) => {
            state.productHandling = action.payload;
        },
        clearProductHandlingInformation: (state) => {
            state.productHandling = {};
        },
        setBillingPTRAInformation: (state, action) => {
            state.billingPTRA = action.payload;
        },
        clearBillingPRAInformation: (state) => {
            state.billingPTRA = {};
        }, 
        setDropdownReducer: (state, action) => {
            state.dropdownData = action.payload;
        },
        setDropDownLoadedFlag: (state) => {
            state.dropDownValuesLoaded = true;
        },
        clearFormData: (state) => {
            state.billing = {};
            state.receiving = {};
            state.requester = {};
            state.shipping = {};
            state.productHandling = {};
            state.billingPTRA = {};
        },
        clearDropDownData: (state) => {
            state.dropdownData = {};
            state.dropDownValuesLoaded = false;
        }
    },
    extraReducers: (builder: any) => {

    }
});

export const { setBillingInformation, setReceivingInformation, setRequestorInformation, setShippingInformation, setProductHandlingInformation, setBillingPTRAInformation, setDropdownReducer, clearFormData, clearDropDownData, setDropDownLoadedFlag, clearRequestorInformation, clearShippingInformation, clearReceivingInformation, clearProductHandlingInformation, clearBillingPRAInformation } = formDataSlice.actions;


export const getBillingInformationPTRA = (state: any) => state.formData.billingPTRA;

export const getBillingInformation = (state: any) => state.formData.billing;

export const getReceivingInformation = (state: any) => state.formData.receiving;

export const getRequesterInformation = (state: any) => state.formData.requester;

export const getShippingInformation = (state: any) => state.formData.shipping;

export const getProductHandlingInformation = (state: any) => state.formData.productHandling;

export const getDropDownInformation = (state: any) => state.formData.dropdownData;

export const getDropDownFlag = (state: any) => state.formData.dropDownValuesLoaded;


export default formDataSlice.reducer;


export const registerExternalUser = createAsyncThunk('registerExternalUser',
    async (payload: any) => {
        const response = await registerNewUser(payload);
        return response
    }
)